<template>
  <v-form ref="form" @submit.prevent="submitForm" class="text-center">
    <v-text-field
      v-model="email"
      :rules="emailRules"
      label="Email"
      required
      type="email"
      autocomplete="off"
      @input="checkEmailValidity"
    ></v-text-field>
    <v-btn
      class="mt-5 white--text"
      type="submit"
      color="#4d51c5"
      rounded
      :loading="loading"
      :disabled="isDisabled"
      block
    >
      Send password reset token
    </v-btn>
    <div style="width: 100%; height: 20px">
      <span :style="messageStyle" v-show="showMessage">{{ messageText }}</span>
    </div>
  </v-form>
</template>

<script>
import services from "../rest/Services";
export default {
  mounted: function () {
    const account = JSON.parse(sessionStorage.getItem("account"));
    if (account) {
      this.email = account.email;
      this.isDisabled = false;
    }
  },
  data() {
    return {
      email: "",
      valid: false,
      loading: false,
      emailRules: [
        (v) => !!v || "Email is required",
        (value) => {
          const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return regex.test(value) || "Invalid email address.";
        },
      ],
      isDisabled: true,
      showMessage: false,
      messageColor: "green",
      messageText: "Reset token sent. Please check your inbox.",
      successText: "Reset token sent. Please check your inbox.",
      errorText: "Email address not found",
    };
  },
  methods: {
    checkEmailValidity() {
      this.isDisabled = !this.$refs.form.validate() || this.email === "";
    },

    submitForm() {
      services
        .createPasswordResetToken({
          email: this.email,
        })
        .then((response) => {
          console.log("response :>> ", response);
          this.createMessage(true);
          this.$refs.form.reset();
          this.$refs.form.resetValidation();
        })
        .catch((error) => {
          console.log("error :>> ", error);
          this.createMessage(false);
        });
    },

    createMessage(isSuccess) {
      this.showMessage = true;
      this.messageText = isSuccess ? this.successText : this.errorText;
      this.messageColor = isSuccess ? "green" : "red";

      setTimeout(() => {
        this.showMessage = false;
      }, 5000);
    },
  },
  computed: {
    messageStyle() {
      return {
        color: this.messageColor,
      };
    },
  },
};
</script>
